<div class="card bg-transparent border-0 shadow mt-3 p-4">
    <div class="card border-0 shadow-sm">
        <div class="card-body" *ngIf="(type!='all')">
            <label class="btn btn-default btn-sm text-center btn-file p-4 py-2 border-{{colorMapping[type]}} w-100" style="border: 2px dotted;">
                <i class="fa fa-cloud-upload fa-3x text-{{colorMapping[type]}}"></i>
                <input type="file" style="display: none;" (change)="uploadFiles($event)" #inputFile multiple>
            </label>
        </div>
        <div class="d-flex justify-content-center" *ngIf="isLoading">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
        <div class="card-body" [hidden]="!(data.length > 0)">
            <div class="table-responsive admin-content">
                <table class="table table-stripped">
                    <thead class="table-light">
                        <tr>
                            <th scope="col" class="col-6 border-0">File Name</th>
                            <th scope="col" class="border-0">Date Uploaded</th>
                            <th scope="col" class="border-0">Actions</th>
                            <th scope="col" class="border-0">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of data | slice:pagination.offset:(pagination.offset+pagination.limit)">
                            <td style="cursor: default;" class="filename-cell">
                                <span [matTooltip]="row.displayName"
                                    matTooltipPosition="above" class="filename-text">
                                    {{ row.displayName }}
                                </span>
                            </td>
                            <td style="cursor: default;">
                                {{row.uploadedDate | date: 'MM/dd/yyyy h:mm a' : '' : 'en-US'}}
                            </td>
                            <td>
                                <i class="fas fa-download clickable" *ngIf="!pdfDownloading[row.uploadedDocumentId]" (click)="downloadFile(row.uploadedDocumentId,row.displayName,row.uploadedFileLink)"></i>  
                                <span *ngIf="pdfDownloading[row.uploadedDocumentId]"><i class="fas fa-circle-notch fa-spin"></i></span>
                                <span *ngIf="isPDF(row.displayName) ||  type === 'all'">
                                    <i class="ms-3 fas fa-eye clickable" *ngIf="!pdfLoading[row.uploadedDocumentId]" (click)="viewFile(row.uploadedDocumentId,row.uploadedFileLink)"></i>
                                    <span *ngIf="pdfLoading[row.uploadedDocumentId]"><i class="ms-3 fas fa-circle-notch fa-spin"></i></span>
                                </span>
                            </td>
                            <td>
                                <span [matTooltip]="getTooltipContent(row)" matTooltipPosition="above" positionAtOrigin="true">
                                    <i [ngClass]="getFileStatusObject(row)?.icon" (click)="searchRecord()" class="ms-3 clickable"></i>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator [length]="pagination.total" [pageSize]="pagination.limit"
                [pageSizeOptions]="[5, 10, 15, 25, 100, 3000]" (page)="pageChange($event)">
            </mat-paginator>
        </div>
    </div>
</div>